import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from './loading.service';
import { AuthService } from './auth.service';
import { environment as env } from '../../environments/environment';
import { ToastService } from './toast.service';
import { llog } from '../@shared/helpers';

@Injectable({
  providedIn: 'root'
})
export class DataSubscriptionsService {

    constructor(
        private http: HttpClient,
        private loadingService: LoadingService,
        private authService: AuthService,
        private toast: ToastService
    ) {}


    // Returns subscription details for user + customer combination
    async get_user_subscriptions(customer: string) {
        if (!customer) throw new Error('Customer not provided');
        let _id = this.loadingService.add('Loading user subscriptions');

        try {
            let res = await this.http.get(`${env.apiUrl}/rest/stripe/subscriptions?customer=${customer}`,
            {            withCredentials: true
            }).toPromise();

            this.loadingService.remove(_id);
            return res;
        }
        catch(e) {
            this.loadingService.remove(_id);
            return { err: e };
        }
    }

    // Update user subscription with selected plan details
    async switch_user_plan(plan: any, customer: string) {
        let _id = this.loadingService.add('Updating subscription');
        
        try {
            let res: any = await this.http.post(`${env.apiUrl}/rest/stripe/switch-plans`,
            {
                plan: plan,
                customer: customer
            },
            {            withCredentials: true
            }).toPromise();

            this.toast.success('Subscription updated successfully.');
            this.loadingService.remove(_id);
            return res;
        }
        catch(e) {
            this.loadingService.remove(_id);
            return { err: e };
        }
    }
}
